import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import I18N from "oc-modules/oc-I18N";

export default function ChangeSizeDialogClosure(options) {
  const onSuccess = options?.onSuccess
    ? options.onSuccess
    : () => {
        APP.arrangement.setPopover(undefined);
      };
  const onDecline = options?.onDecline
    ? options.onDecline
    : () => {
        APP.arrangement.dialog = undefined;
        APP.dirty();
      };

  return function ChangeSizeDialog() {
    return (
      <div>
        <DialogTitle id="alert-dialog-title">{I18N("Attention")}</DialogTitle>
        <DialogContent>{I18N("ChangeSizeAlertContent")}</DialogContent>
        <DialogActions>
          <Button onClick={onDecline} autoFocus>
            {I18N("decline")}
          </Button>
          <Button onClick={onSuccess}>{I18N("Ok")}</Button>
        </DialogActions>
      </div>
    );
  };
}
